var script = document.createElement('script');
script.src = "//js-eu1.hs-scripts.com/".concat(process.env.HUBSPOT_ID, ".js");
document.body.appendChild(script); // create a global variable for the HubSpot script to use if it does not yet exist

window._hsq = window._hsq || [];